// extracted by mini-css-extract-plugin
export default {"Nutshell":"Defs_Nutshell__M5ElY","Iam":"Defs_Iam__lYTYQ","Value":"Defs_Value__KlFVn","Param":"Defs_Param__UQkMs","Return":"Defs_Return__hr1XY"};